module.exports = __webpack_public_path__ + "static/media/Barnum–Forer Effect.c2f3fcc2.jpg";